const EMBED_SCRIPT_URL = 'https://www.instagram.com/embed.js';

let embedScriptPromise = null;

function loadEmbedScript() {
  if (window.instgrm) {
    return Promise.resolve();
  }

  if (!embedScriptPromise) {
    embedScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = EMBED_SCRIPT_URL;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Instagram embed.js'));
      document.body.appendChild(script);
    }).catch((error) => {
      // Don't memoize a failed load — a transient blip would otherwise wedge
      // every Instagram embed on the page for the rest of its lifetime.
      embedScriptPromise = null;
      throw error;
    });
  }

  return embedScriptPromise;
}

export default () => ({
  processed: false,

  // Triggered by the intersect directive once the placeholder enters the
  // viewport — the real <blockquote> (with Meta's own loading skeleton) is
  // already visible either way, this only decides when embed.js runs.
  autoReveal() {
    this.process();
  },

  // Manual retry if a previous process() failed.
  handleContentClick(event) {
    if (this.processed) {
      return;
    }

    event.preventDefault();
    this.process();
  },

  process() {
    if (this.processed) {
      return;
    }

    this.processed = true;

    loadEmbedScript()
      .then(() => {
        window.instgrm && window.instgrm.Embeds.process();
      })
      .catch(() => {
        // Allow a retry (another click) instead of silently leaving this
        // embed stuck as Meta's static skeleton forever.
        this.processed = false;
      });
  },
});
